import { budgetTransactionsRouteProps } from 'src/navigation/routeProps'
import { createBackgroundReducer } from 'src/redux/genericReducers'
import UsersFullPaginatedDataReducer, {
  Actions as UsersFullPaginatedDataActions,
  initialState as initialUsersFullPaginatedDataState,
  UsersFullPaginatedDataState,
} from 'src/redux/usersFullPaginatedData.reducer'

export type BudgetTransactionsState = {
  usersFullPaginatedData: UsersFullPaginatedDataState
}

export const initialState: BudgetTransactionsState = {
  usersFullPaginatedData: initialUsersFullPaginatedDataState,
}

export type Actions = UsersFullPaginatedDataActions

const CoreBudgetTransactionsReducer = (
  state = initialState,
  action: Actions,
): BudgetTransactionsState => ({
  usersFullPaginatedData: UsersFullPaginatedDataReducer(
    state.usersFullPaginatedData,
    action as UsersFullPaginatedDataActions,
  ),
})

const BudgetTransactionsReducer = createBackgroundReducer(
  budgetTransactionsRouteProps,
  initialState,
  CoreBudgetTransactionsReducer,
)

export default BudgetTransactionsReducer
